import type { FC } from 'react';
import { Card, SkeletonAnimatedContainer, StatusInfo } from '@george-labs.com/design-system';

import { ConditionalWrapper } from '@luna/utils-ui';

interface Props {
    wrapWithCard?: true;
    'data-cy'?: string;
}

export const InlineSigningSkeleton: FC<Props> = ({
    wrapWithCard = false,
    'data-cy': dataCy = 'inline-signing-skeleton-loader',
}) => (
    <ConditionalWrapper condition={wrapWithCard} wrapper={Card}>
        <SkeletonAnimatedContainer>
            <StatusInfo icon={StatusInfo.ICON.SIGN} title="" data-cy={dataCy} />
        </SkeletonAnimatedContainer>
    </ConditionalWrapper>
);
